export let
	URL_PREFIX;

switch(true) {
	case (process.env.NODE_ENV === 'development'):
	case (process.env.NODE_ENV === '"development"'):
		URL_PREFIX = 'http://localhost:8081'
		break
	case (process.env.NODE_ENV === 'production'):
	case (process.env.NODE_ENV === '"production"'):
		URL_PREFIX = 'https://app.techinterview.co'
		break
	case (process.env.NODE_ENV === 'staging'):
	case (process.env.NODE_ENV === '"staging"'):
		URL_PREFIX = 'https://staging.techinterview.co'
		break
}

export const PRICE_MONTHLY_COMPANY = 1995

export const COMPANY_LIST = [
	{
		company: 'facebook',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'google',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'microsoft',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'amazon',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'apple',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'snap',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'yelp',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'linkedin',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'twitter',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'bloomberg',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'uber',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
	{
		company: 'goldman',
		subscriptionId: null,
		subscriptionExpireDate: null,
	},
]



// WEBPACK FOOTER //
// ./src/constants.js